module.exports = __webpack_public_path__ + "static/media/Colette Velvet Queen Base - 155x205 cm_Beige.fe5f93c9.png";